import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { color, spacing } from '@lightspeed/cirrus-tokens/utils';

export const DetailsContainer = styled('div')`
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  flex-direction: row;
  margin-bottom: ${spacing(4)};
  & .cr-icon {
    min-width: 1rem;
  }
`;

export const ShopToVendorContainer = styled('div')`
  margin-right: ${spacing(3)};
  display: inline-flex;
  flex: 1;
`;

export const StatusCreatedByContainer = styled('div')`
  display: inline-flex;
  text-align: right;
  justify-content: flex-end;
`;

export const DatesContainer = styled('div')`
  display: inline-flex;
  flex-direction: row;
`;

export const DateSentContainer = styled('div')`
  width: auto;
  margin: 0 0 0 ${spacing(3)};
  padding: 0 0 0 ${spacing(3)};
  border-left: solid 1px ${color('gray-100')};
  text-align: right;
`;

export const DateClosedContainer = styled('div')`
  width: auto;
  margin: 0 0 0 ${spacing(3)};
  padding: 0 0 0 ${spacing(3)};
  border-left: solid 1px ${color('gray-100')};
  text-align: right;
`;

export const breakWord = css`
  word-break: break-word;
`;
